const LEVEL_STYLES = {
  Beginner: "bg-slate-50 text-slate-600 ring-slate-100",
  Intermediate: "bg-blue-50 text-blue-700 ring-blue-100",
  Advanced: "bg-amber-50 text-amber-700 ring-amber-100",
  Expert: "bg-[#D6FFEB] text-[#B03A3A] ring-[#B8FFDD]",
};

export default function ToolBadge({ tool, level, size = "sm" }) {
  const pad = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm";
  return (
    <span
      data-testid={`tool-badge-${tool.replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full ring-1 font-medium ${pad} ${LEVEL_STYLES[level] || LEVEL_STYLES.Intermediate}`}
    >
      <span>{tool}</span>
      {level && (
        <span className="opacity-70 text-[10px] uppercase tracking-wider font-semibold">
          · {level}
        </span>
      )}
    </span>
  );
}
